export const listRedeSocial = [
  { id: "youtube", name: "Planium Bank", icon: "youtube", link: "https://www.youtube.com/channel/UCcM4Rh7728dnzId_bwPnrkg" },
  { id: "facebook", name: "Planium Bank", icon: "facebook", link: `#home` },
  { id: "instagram", name: "Planium Bank", icon: "instagram", link: `#home` },
  { id: "twitter", name: "@PlaniumBank", icon: "twitter", link: `#home` },
]